import React, { useEffect } from "react";
import ContactLinks from "../components/ContactLinks";
import resume from "../data/resume.json";
import { getPositions } from "../helpers/resume";
import { setRandomBackground } from "../helpers/backgroundHelpers";
import "./Resume.css";

const Resume: React.FC = () => {
  useEffect(() => {
    setRandomBackground();
  }, []);

  return (
    <div className="resume-page">
      <header className="resume-intro">
        <p className="resume-eyebrow">Resume / {resume.location}</p>
        <h1>{resume.name}</h1>
        <p className="resume-title">{resume.title}</p>
        <p className="resume-specialty">{resume.specialty}</p>
        <p className="resume-summary">{resume.summary}</p>
        <div className="resume-downloads" aria-label="Resume downloads">
          <a
            className="resume-download resume-download-primary"
            href={`${process.env.PUBLIC_URL}/downloads/RobynSeverson.pdf`}
            download="RobynSeverson.pdf"
          >
            <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
              <path d="M12 3v12m-5-5 5 5 5-5M5 16v5h14v-5" />
            </svg>
            Download PDF
          </a>
          <a
            className="resume-download"
            href={`${process.env.PUBLIC_URL}/downloads/RobynSeverson.docx`}
            download="RobynSeverson.docx"
          >
            Download Word (.docx)
          </a>
        </div>
      </header>

      <section className="resume-section" aria-labelledby="skills-heading">
        <h2 id="skills-heading">Technical expertise</h2>
        <div className="resume-skills">
          {resume.skills.map((group) => (
            <div className="resume-skill-group" key={group.label}>
              <h3>{group.label}</h3>
              <p>{group.items.join(" · ")}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="resume-section" aria-labelledby="exp-heading">
        <h2 id="exp-heading">Experience</h2>
        <ol className="resume-positions">
          {getPositions().map((position) => (
            <li className="resume-position" key={`${position.company}-${position.start}`}>
              <div className="resume-position-heading">
                <div>
                  <p className="resume-company">{position.company}</p>
                  <h3>{position.title}</h3>
                </div>
                <p className="resume-dates">{position.start} – {position.end}</p>
              </div>
              <ul>
                {position.descriptions.map((description) => (
                  <li key={description}>{description}</li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      </section>

      <section className="resume-section" aria-labelledby="credentials-heading">
        <h2 id="credentials-heading">Credentials</h2>
        {resume.credentials.map((credential) => (
          <p className="resume-credential" key={credential.name}>
            <strong>{credential.name}</strong>
            <span>{credential.issuer} · {credential.date}</span>
          </p>
        ))}
      </section>

      <section className="resume-section" aria-labelledby="contact-heading">
        <h2 id="contact-heading">Let's connect</h2>
        <p className="resume-contact-intro">
          For engineering opportunities and conversations, get in touch.
        </p>
        <ContactLinks />
      </section>
    </div>
  );
};

export default Resume;
